import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface LightningIconProps {
  color?: string;
  opacity?: number;
  size?: number;
  [x: string]: unknown;
}

const LightningIcon = ({ color, ...rest }: LightningIconProps) => {
  const { token } = useToken();
  return (
    <span role="img" aria-label="lightning" className="anticon">
      <svg
        viewBox="0 0 18 19"
        focusable="false"
        width="1em"
        height="1em"
        fill="currentColor"
        aria-hidden="true"
        {...rest}
      >
        <path
          d="M15.1728 8.70884C15.1515 8.61869 15.1082 8.53519 15.0469 8.46576C14.9856 8.39634 14.908 8.34313 14.8212 8.31087L10.7705 6.79142L11.8013 1.6354C11.8246 1.51561 11.8084 1.39147 11.755 1.28172C11.7016 1.17197 11.6139 1.08257 11.5052 1.02701C11.3966 0.971441 11.2728 0.952729 11.1525 0.973692C11.0323 0.994655 10.9221 1.05416 10.8387 1.14322L2.9637 9.58072C2.89974 9.64811 2.85347 9.7303 2.82902 9.81994C2.80458 9.90958 2.80272 10.0039 2.82361 10.0944C2.8445 10.185 2.8875 10.2689 2.94875 10.3388C3.01 10.4086 3.08761 10.4622 3.17463 10.4948L7.22674 12.0142L6.19877 17.1646C6.17543 17.2844 6.19169 17.4086 6.24509 17.5183C6.29849 17.6281 6.38614 17.7175 6.49481 17.773C6.60348 17.8286 6.72727 17.8473 6.84751 17.8263C6.96774 17.8054 7.0779 17.7459 7.16135 17.6568L15.0364 9.21931C15.0992 9.1519 15.1444 9.0701 15.1682 8.98109C15.192 8.89208 15.1936 8.79859 15.1728 8.70884ZM7.6901 15.4469L8.42627 11.7639C8.45262 11.6333 8.43174 11.4976 8.36736 11.3809C8.30298 11.2642 8.19927 11.1742 8.07471 11.1269L4.3594 9.73119L10.3092 3.35665L9.57377 7.03962C9.54743 7.17024 9.5683 7.30597 9.63269 7.42264C9.69707 7.5393 9.80078 7.62932 9.92534 7.67666L13.6378 9.06884L7.6901 15.4469Z"
          fill={color ?? token.colorPrimary}
        />
      </svg>
    </span>
  );
};

export default LightningIcon;
